import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface AppHeaderPortalProps {
  children: React.ReactNode;
}

export const AppHeaderPortal = ({ children }: AppHeaderPortalProps) => {
  const [mounted, setMounted] = useState(false);
  const [portalRoot, setPortalRoot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setMounted(true);

    const root = document.getElementById('header-portal');
    setPortalRoot(root);

    if (!root) {
      const timer = setTimeout(() => {
        const delayedRoot = document.getElementById('header-portal');
        setPortalRoot(delayedRoot);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, []);

  if (!mounted || !portalRoot) {
    return null;
  }

  return createPortal(children, portalRoot);
};
